<template>
  <div class="page" :style="{ backgroundImage: !pageData.hasCj ? '' : 'linear-gradient(224deg, #fd9567 0%, #f9dfa4 100%)' }">
    <van-nav-bar title="实习成绩" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="empty" v-if="!pageData.hasCj">
      <img src="../../../../assets/images/sx_empty.png" alt="" />
      <div>暂无实习成绩</div>
    </div>
    <img v-if="pageData.hasCj" class="back back-top" src="../../../../assets/images/achieve_back1.png" alt="" />
    <img v-if="pageData.hasCj" class="back back-bottom" src="../../../../assets/images/achieve_back2.png" alt="" />
    <div class="achieve-box" v-if="pageData.hasCj">
      <img src="../../../../assets/images/achieve_icon.png" alt="" />
      <div class="text-box">
        <div class="score">{{ pageData.sxcj }}</div>
        <div class="info">
          <div>{{ pageData.jhname }}</div>
          <div class="time">实习时间: {{ pageData.starttime }}～{{ pageData.endtime }}</div>
        </div>
        <div class="user-info">
          <div>姓名：{{ pageData.name }}（{{ pageData.stunum }}）</div>
          <div>班级：{{ pageData.bj }}</div>
        </div>
        <div class="work-info">
          <div class="item">
            <div class="title">实习单位</div>
            <div class="content">{{ pageData.company }}</div>
          </div>
          <div class="item">
            <div class="title">部门/科室</div>
            <div class="content">{{ pageData.depart }}</div>
          </div>
          <div class="item">
            <div class="title">实习岗位</div>
            <div class="content">{{ pageData.pos }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="pageData.hasCj" class="done-button" @click="$router.go(-1)">知道了</div>
  </div>
</template>

<script>
import iApi from '@/utils/internship'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      showEmpty: false,
      pageData: {
        stunum: '', //学号
        pos: '', //岗位
        hasCj: false, //是否有成绩
        jhname: '', //实习计划名称
        bj: '', //班级
        name: '', //姓名
        endtime: '', //计划结束时间
        company: '', //企业
        sxcj: '', //实习成绩
        starttime: '', //计划开始时间
        depart: '', //部门
      },
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
    }),
  },
  async created() {
    const res = await iApi.getAchieveData({
      sxjhid: this.sxjhid,
    })
    this.pageData = res.data
  },
}
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
  position: relative;
}
.empty {
  // margin-top: 167px;
  height: calc(100vh - 46px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 16px;
  color: #666666;
  text-align: center;
  img {
    width: 159px;
    height: 154px;
    margin-bottom: 30px;
  }
}
.back {
  position: fixed;
  right: 0;
  left: 0;
  width: 100%;
}
.back-top {
  top: 0;
}
.back-bottom {
  bottom: 0;
}
.achieve-box {
  position: relative;
  img {
    width: 335px;
    height: 580px;
    // box-shadow: 5px 5px 1px 0 rgba(74,46,23,0.15);
    margin: 50px auto 0;
    display: block;
    position: relative;
    z-index: 999;
  }
  .text-box {
    width: 100%;
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 9999;
    transform: translate(-50%);
    .score {
      margin-top: 97px;
      text-align: center;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 22px;
      color: #c75e06;
    }
    .info {
      margin-top: 117px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 16px;
      color: #e64e33;
      text-align: center;
      .time {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #f76650;
      }
    }
    .user-info {
      width: 265px;
      min-height: 62px;
      background: #f2f2f4;
      border-radius: 6px;
      margin: 49px auto 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      padding: 0 15px;
    }
    .work-info {
      margin: 12px auto 0;
      .item {
        margin: 0 auto;
        width: 265px;
        height: 50px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        .title {
          min-width: 92px;
        }
        .content {
          flex: 1;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          text-align: right;
        }
      }
    }
  }
}
.done-button {
  position: relative;
  z-index: 999;
  width: 325px;
  height: 50px;
  background: #ffffff;
  box-shadow: 5px 5px 1px 0 rgba(74, 46, 23, 0.15);
  border-radius: 8px;
  margin: 28px auto 0;
  text-align: center;
  line-height: 50px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 18px;
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/achievement.vue